import React, { useState } from "react";
import {
    Box, List, ListItem, Avatar, Typography, ListItemButton, IconButton, Paper, TextField, Divider, Button, Dialog, DialogTitle, DialogContent, DialogActions, Slide,
    CircularProgress
} from "@mui/material";
import { CallMade, CallReceived, Dialpad, Search, Call, Close, Backspace } from "@mui/icons-material";

const pastelColors = ["#FFD1DC", "#FFECB3", "#C8E6C9", "#BBDEFB", "#D1C4E9", "#FFCCBC"];

const getAvatarColor = (name, index) => {
    if (!name) return pastelColors[index % pastelColors.length];
    return pastelColors[name.charCodeAt(0) % pastelColors.length];
};

const Recruitervoicecall = () => {
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedContact, setSelectedContact] = useState(null);
    const [showDialpad, setShowDialpad] = useState(false);
    const [callDialog, setCallDialog] = useState(false);
    const [dialedNumber, setDialedNumber] = useState("");
    const [connections, setConnections] = useState([
        { id: 1, recruiter_name: "John Doe", callType: "Outgoing", duration: "02:15", time: "10:30 AM", recording: "audio1.mp3" },
        { id: 2, recruiter_name: "Jane Smith", callType: "Incoming", duration: "01:45", time: "11:15 AM", recording: "audio2.mp3" },
    ]);

    const handleDialpadClick = (num) => {
        setDialedNumber((prev) => prev + num);
    };

    const handleBackspace = () => {
        setDialedNumber(dialedNumber.slice(0, -1));
    };

    const handleCallClick = () => {
        if (dialedNumber) {
            const newCall = {
                id: connections.length + 1,
                recruiter_name: dialedNumber,
                callType: "Outgoing",
                duration: "00:00",
                time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
                recording: null
            };

            setConnections([newCall, ...connections]); // Add new call to the list
            setDialedNumber(""); // Reset the dialed number
        }
        setCallDialog(true);
    };

    return (
        <Box display="flex" height="100vh" p={1} bgcolor="grey.100">
            {/* Left Sidebar */}
            <Paper sx={{ width: "350px", height: "100%", p: 2, boxShadow: 3, borderRadius: 2 }}>
                <Box display="flex" alignItems="center" gap={1} mb={2}>
                    <TextField
                        variant="outlined"
                        size="small"
                        placeholder="Search recruiters..."
                        fullWidth
                        InputProps={{
                            startAdornment: <Search sx={{ color: "#888", mr: 1 }} />,
                        }}
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                    <IconButton onClick={() => setShowDialpad(!showDialpad)}>
                        <Dialpad />
                    </IconButton>
                </Box>

                {/* Dialpad */}
                <Slide direction="down" in={showDialpad} mountOnEnter unmountOnExit>
                    <Paper sx={{ p: 3, mb: 3, textAlign: "center", bgcolor: "#f5f5f5", borderRadius: 3, boxShadow: 3 }}>
                        <Typography variant="h6" sx={{ my: 2, textAlign: "center", fontWeight: "bold", fontSize: "16px", color: "#333" }}>
                            <Box display="flex" justifyContent="space-between" alignItems="center">
                                <span style={{ color: dialedNumber ? "#000" : "#9e9e9e" }}>
                                    {dialedNumber || "Enter Number"}
                                </span>
                                <Backspace
                                    onClick={handleBackspace}
                                    disabled={dialedNumber.length === 0}
                                    style={{
                                        fontSize: "24px",
                                        cursor: dialedNumber.length === 0 ? 'not-allowed' : 'pointer',
                                        color: dialedNumber.length === 0 ? "#bdbdbd" : "#f44336",
                                        transition: "color 0.3s ease"
                                    }}
                                />
                            </Box>
                        </Typography>

                        <Box display="grid" gridTemplateColumns="repeat(3, 1fr)" gap={2} mt={2}>
                            {Array.from({ length: 9 }, (_, i) => (
                                <Button
                                    key={i + 1}
                                    variant="outlined"
                                    sx={{
                                        borderRadius: "50%",
                                        width: "60px",
                                        height: "60px",
                                        color: "#000",
                                        fontSize: "18px",
                                        borderColor: "#dcdcdc",
                                        '&:hover': { borderColor: "#757575", backgroundColor: "#f0f0f0" },
                                        lineHeight: "1.5"
                                    }}
                                    onClick={() => handleDialpadClick(i + 1)}
                                >
                                    {i + 1}
                                </Button>
                            ))}
                            <Button variant="outlined" sx={{ borderRadius: "50%", width: "60px", height: "60px", color: "#000", fontSize: "18px" }} onClick={() => handleDialpadClick("*")}>*</Button>
                            <Button variant="outlined" sx={{ borderRadius: "50%", width: "60px", height: "60px", color: "#000", fontSize: "18px" }} onClick={() => handleDialpadClick("0")}>0</Button>
                            <Button variant="outlined" sx={{ borderRadius: "50%", width: "60px", height: "60px", color: "#000", fontSize: "18px" }} onClick={() => handleDialpadClick("+")}>+</Button>
                        </Box>

                        <Box mt={3}>
                            <Button
                                variant="contained"
                                color="success"
                                startIcon={<Call />}
                                sx={{
                                    borderRadius: "50%",
                                    width: 70,
                                    paddingLeft:"22px",
                                    height: 70,
                                    fontSize: "24px",
                                    boxShadow: 3,
                                    '&:hover': { backgroundColor: "#388e3c", boxShadow: 6 },
                                    transition: "background-color 0.3s ease"
                                }}
                                onClick={handleCallClick}
                            />
                        </Box>
                    </Paper>


                </Slide>

                {/* Calls List */}
                <List>
                    {connections
                        .filter((c) => c.recruiter_name.toLowerCase().includes(searchTerm.toLowerCase()))
                        .map((contact, index) => (
                            <ListItem key={contact.id} disablePadding sx={{ borderBottom: "1px solid #ebe6e6" }}>
                                <ListItemButton onClick={() => setSelectedContact(contact)}>
                                    <Avatar sx={{ color: "#000", fontSize: "12px", bgcolor: getAvatarColor(contact.recruiter_name, index) }}>
                                        {contact.recruiter_name.charAt(0).toUpperCase()}
                                    </Avatar>
                                    <Box sx={{ flexGrow: 1, ml: 2 }}>
                                        <Typography variant="body1" fontWeight="bold">
                                            {contact.recruiter_name}
                                        </Typography>
                                        <Typography variant="body2" color="textSecondary" display="flex" alignItems="center">
                                            {contact.callType === "Outgoing" ? (
                                                <CallMade sx={{ fontSize: 16, color: "green", mr: 1 }} />
                                            ) : (
                                                <CallReceived sx={{ fontSize: 16, color: "blue", mr: 1 }} />
                                            )}
                                            {contact.callType} Call
                                        </Typography>
                                    </Box>
                                    <Typography variant="body2" sx={{ color: "#666", fontSize: "12px" }}>
                                        {contact.time}
                                    </Typography>
                                </ListItemButton>
                            </ListItem>
                        ))}
                </List>
            </Paper>

            {/* Call History Section */}
            <Paper sx={{ flex: 1, ml: 2, p: 3, boxShadow: 3, borderRadius: 2 }}>
                {selectedContact ? (
                    <>
                        <Typography variant="h6" fontWeight="bold" sx={{fontSize:"15px"}}>Call History</Typography>
                        <Divider sx={{ my: 2 }} />

                        <Box display="flex" alignItems="center" justifyContent="space-between" gap={2}>
                            <Box display="flex" alignItems="center" gap={2}>
                                <Avatar sx={{ color: "#000", bgcolor: getAvatarColor(selectedContact.recruiter_name, selectedContact.id) }}>
                                    {selectedContact.recruiter_name.charAt(0).toUpperCase()}
                                </Avatar>
                                <Box>
                                    <Typography variant="h5" fontWeight="bold">{selectedContact.recruiter_name}</Typography>
                                    <Typography variant="body1" color="textSecondary">{selectedContact.time}</Typography>
                                    <Typography variant="body2">{selectedContact.callType} Call</Typography>
                                </Box>
                            </Box>
                            <IconButton tooltip="Call"
                                color="primary"
                                sx={{
                                    bgcolor: "green",
                                    color: "white",
                                    '&:hover': {
                                        bgcolor: "green",  // Maintain the same green background on hover
                                        color: "white"     // Maintain the same white icon color on hover
                                    }
                                }}
                                onClick={handleCallClick}
                            >
                                <Call />
                            </IconButton>

                        </Box>

                        <Box mt={3} p={2} bgcolor="#f9f9f9" borderRadius={2}>
                            <Typography variant="subtitle1" fontWeight="bold">Call Recording</Typography>
                            <Typography variant="body2" sx={{ float: "right" }}>Duration: {selectedContact.duration}</Typography>
                            <audio controls style={{ width: "100%" }}>
                                <source src={selectedContact.recording} type="audio/mp3" />
                            </audio>
                        </Box>
                    </>
                ) : (
                    <Typography variant="h6" color="textSecondary">Select a recruiter to view call history</Typography>
                )}
            </Paper>

            {/* Call Dialog */}
            <Dialog open={callDialog} onClose={() => setCallDialog(false)} sx={{ borderRadius: 2, minWidth: '400px', padding: '20px' }}>
                <DialogTitle sx={{
                    fontWeight: 'bold',
                    fontSize: '1.4rem',
                    color: '#1976d2',
                    borderBottom: '1px solid #ddd',
                    paddingBottom: '10px'
                }}>
                    Calling...
                </DialogTitle>
                <DialogContent sx={{
                    padding: 3,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    bgcolor: 'rgba(0, 0, 0, 0.05)',
                    borderRadius: '8px'
                }}>
                    <Typography variant="body1" color="textSecondary" sx={{
                        fontSize: '1rem',
                        fontWeight: '500',
                        marginBottom: '20px'
                    }}>
                        Dialing recruiter {dialedNumber}, please wait...
                    </Typography>
                    <Box display="flex" justifyContent="center" mt={2}>
                        <CircularProgress color="primary" />
                    </Box>
                </DialogContent>
                <DialogActions sx={{
                    padding: '15px 20px',
                    display: 'flex',
                    justifyContent: 'center',
                }}>
                    <Button color="secondary" onClick={() => setCallDialog(false)}>
                        <Close />
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default Recruitervoicecall;
